// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import searchOnlineCoursesSelector from '../../redux/selectors/searchOnlineCoursesSelector';
import { actionCreatorsList } from '../../redux/rootActionCreator';
import { ProductCard } from '../../components/NewCard/types';
import { KeywordTitle } from '../../redux/actionCreators/search/searchOnlineCoursesKeywordActions';
import { SearchCondition } from '../../types/Model';

const {
  searchOnlineCoursesActions,
  searchOnlineCoursesKeywordActions
} = actionCreatorsList;

export function useSearchOnlineCourses(limit: number, page: number, condition: SearchCondition): () => void {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(searchOnlineCoursesActions.request({
      limit,
      page,
      condition
    }));
  }, [condition, page])
}

export function useSearchOnlineCoursesKeywords(limit: number, name: string): () => void {
  const dispatch = useDispatch();

  return useCallback(() => {
    if (name.length > 0) {
      dispatch(searchOnlineCoursesKeywordActions.request({
        limit,
        name
      }));
    }
  }, [limit, name])
}

export function useIsFetching(): boolean {
  return useSelector(searchOnlineCoursesSelector.makeIsFetching())
}

export function useOnlineCourseList(): ProductCard[] {
  return useSelector(searchOnlineCoursesSelector.makeSearchOnlineCourses());
}

export function useError(): Error | undefined {
  return useSelector(searchOnlineCoursesSelector.makeError());
}

export function useKeywords(keyword: string): KeywordTitle[] {
  return useSelector(searchOnlineCoursesSelector.makeSearchKeywordByKey(keyword));
}

export function useHasMoreResults(): boolean {
  return useSelector(searchOnlineCoursesSelector.makeHasMore());
}

export function useIsMoreFetching(): boolean {
  return useSelector(searchOnlineCoursesSelector.makeIsMoreFetching())
}

export function useCommonKeywords(keyword: string): KeywordTitle[] {
  return useSelector(searchOnlineCoursesSelector.makeSearchCommonKeywordByKey(keyword))
}
